import React from 'react';
import { Link } from 'react-router-dom';
import { Cloud, ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-[#1a1a2e]">
      {/* Header */}
      <header className="glass-header fixed top-0 left-0 right-0 z-50 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <Cloud className="w-8 h-8 text-[#39FF14]" />
            <span className="font-bold text-xl text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
              FART BUTTON
            </span>
          </Link>
          <Link 
            to="/" 
            className="flex items-center gap-2 text-[#A0A0C0] hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            Back to Home
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="pt-32 pb-24 px-6">
        <div className="max-w-3xl mx-auto">
          <h1 
            className="text-4xl font-black text-white mb-8"
            style={{ fontFamily: 'Unbounded, sans-serif' }}
          >
            Terms of Service
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-6 text-[#A0A0C0]">
            <p className="text-lg">
              Last updated: January 2026
            </p>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                1. Acceptance of Terms
              </h2>
              <p>
                By downloading, installing, or using Fart Button Madness ("the App"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the App.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                2. Description of Service
              </h2>
              <p>
                Fart Button Madness is an entertainment application that provides:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>A variety of fart sound effects</li>
                <li>Achievement badges and ranking system</li>
                <li>Global leaderboards</li>
                <li>Mini-games and challenges</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                3. User Conduct
              </h2>
              <p>You agree to use the App responsibly and not to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Use the App in any way that violates applicable laws</li>
                <li>Attempt to hack, reverse engineer, or exploit the App</li>
                <li>Use offensive or inappropriate usernames on leaderboards</li>
                <li>Manipulate scores or rankings through cheating</li>
                <li>Use the App to harass or disturb others</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                4. Intellectual Property
              </h2>
              <p>
                All content in the App, including but not limited to sounds, graphics, text, and code, is owned by Fart Button Madness or its licensors and is protected by copyright and other intellectual property laws. Sound effects are sourced from Freesound.org under appropriate licenses.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                5. User Accounts
              </h2>
              <p>
                If you create an account, you are responsible for maintaining the security of your account and all activities that occur under it. You must provide accurate information and keep it updated.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                6. In-App Purchases
              </h2>
              <p>
                The App may offer in-app purchases. All purchases are final and non-refundable unless required by applicable law. Prices are subject to change without notice.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                7. Disclaimer of Warranties
              </h2>
              <p>
                THE APP IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS OR IMPLIED. WE DO NOT GUARANTEE THAT THE APP WILL BE ERROR-FREE, UNINTERRUPTED, OR FREE OF HARMFUL COMPONENTS.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                8. Limitation of Liability
              </h2>
              <p>
                TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING FROM YOUR USE OF THE APP.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                9. Termination
              </h2>
              <p>
                We reserve the right to terminate or suspend your access to the App at any time, without notice, for conduct that we believe violates these Terms or is harmful to other users or us.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                10. Changes to Terms
              </h2>
              <p>
                We may modify these Terms at any time. Continued use of the App after changes constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                11. Governing Law
              </h2>
              <p>
                These Terms shall be governed by and construed in accordance with applicable laws, without regard to conflict of law principles.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Unbounded, sans-serif' }}>
                12. Contact
              </h2>
              <p>
                For questions about these Terms, please visit our{' '}
                <Link to="/contact" className="text-[#39FF14] hover:underline">
                  contact page
                </Link>.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-white/10">
        <div className="max-w-7xl mx-auto text-center text-[#A0A0C0] text-sm">
          © 2026 Fart Button Madness. Every fart is unique!
        </div>
      </footer>
    </div>
  );
};

export default TermsOfService;
